import { render, staticRenderFns } from "./dnsTicketModal.vue?vue&type=template&id=045a9408&scoped=true"
import script from "./dnsTicketModal.vue?vue&type=script&lang=js"
export * from "./dnsTicketModal.vue?vue&type=script&lang=js"
import style0 from "./dnsTicketModal.vue?vue&type=style&index=0&id=045a9408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045a9408",
  null
  
)

export default component.exports